import React from "react";
import { Container, Col, Navbar, Nav, NavItem } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import ProfileMenu from "../profile/ProfileMenu";
import { useImpersonation } from "../../../contexts/ImpersonationContext";

function NavigationHeader(props) {
  const { isImpersonating } = useImpersonation();
  
  return (
    <Container className="navigation-header" fluid>
      <Navbar className="navbar-expand-lg">
        <Col>
          <a href="/" className="navbar-brand" style={{ padding: "5px" }}>
            <span style={{ paddingRight: "10px" }}>
              <img style={{ width: "165px" }} src="/rba-logo.png" alt="Logo" />
            </span>
          </a>
        </Col>
        <Col>
          <Nav variant="pills" defaultActiveKey="/pto/">
            <NavItem>
              <NavLink to="/pto/" className="nav nav-link">
                PTO
              </NavLink>
            </NavItem>
            {((!isImpersonating && (props.profile.employeeType === "BILL")) || props.isAdmin || props.profile.isManager)
              || (props.isAdmin && isImpersonating && props.profile.ghostEmployeeType === "BILL") ? (
                    <NavItem>
                      <NavLink to="/revshare/" className="header-pill nav-link">
                        Rev Share
                      </NavLink>
                    </NavItem>                
              ) : null}
            { (!isImpersonating && props.profile.showOptions)
              || (props.isAdmin && isImpersonating && props.profile.ghostShowOptions) ?
              <NavItem>
                <NavLink to="/options/" className="nav-link">
                  Options
                </NavLink>
              </NavItem> : ""             
            }
            {(!isImpersonating && (props.profile.employeeType === "BILL" || props.profile.isManager))
              || (props.isAdmin && isImpersonating && (props.profile.ghostEmployeeType === "BILL" || props.profile.ghostIsManager)) ? (
                    <NavItem>
                      <NavLink to="/presclub/" className="nav-link">
                        President's Club
                      </NavLink>
                    </NavItem>                
              ) : null}
            { (!isImpersonating && props.profile.showVouchers)
              || (props.isAdmin && isImpersonating && props.profile.ghostShowVouchers) ?
              <NavItem>
                <NavLink to="/travel/" className="nav-link">
                  Allowances
                </NavLink>
              </NavItem> : ""             
            }
            {props.isAdmin && !isImpersonating ? (
              <NavItem>
                <NavLink to="/administration/admin" className="nav-link">
                  Administration
                </NavLink>
              </NavItem>
            ) : null}
          </Nav>
        </Col>
        <Col xs="auto">
          <ProfileMenu profile={props.profile} logout={props.logout} />
        </Col>
      </Navbar>
    </Container>
  );
}

export default NavigationHeader;